import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../i18n/LanguageContext';

const DOMAIN = 'https://rteqsolutions.com';
const LOGO = 'https://customer-assets.emergentagent.com/job_preview-suite/artifacts/bkqjgsqq_RteQ_Solutions_Logo-removebg-preview.png';

const seoData = {
  en: {
    '/': {
      title: 'RTEQ Solutions | All-in-one platform for chip tuning & automotive solution',
      description: 'RTEQ Solutions is an all-in-one cloud platform for professional ECU chip tuning, remote automotive diagnostics, and vehicle software management. Supporting cars, bikes, trucks, marine & agriculture vehicles.',
      keywords: 'ECU tuning, chip tuning, automotive diagnostics, remote diagnostics, ECU remapping, Stage 1 tuning, Stage 2 tuning, DPF solutions, EGR solutions, automotive software, vehicle tuning platform, professional tuning software, car tuning, truck tuning, marine tuning, agriculture vehicle tuning, WinOLS, flash tool, ECU file service',
    },
    '/suite': {
      title: 'RTEQ Portal | Cloud-Based Automotive Tuning & Diagnostics Software',
      description: 'RTEQ Portal is a modular cloud platform for managing ECU tuning jobs, remote diagnostics, file services, and vehicle databases. Built for professional garages and tuning workshops worldwide.',
      keywords: 'RTEQ Portal, automotive tuning platform, cloud tuning software, ECU file management, vehicle diagnostics software, tuning job management, remote diagnostics platform, garage management software, tuning workshop software, automotive workflow',
    },
    '/services': {
      title: 'ECU Tuning & Diagnostics Services | Stage 1-3 Tuning, DPF, EGR | RTEQ Solutions',
      description: 'Professional ECU tuning services including Stage 1, 2, 3 tuning, DPF & EGR solutions, AdBlue modifications, custom tuning, remote diagnostics, and integrated automotive software tools.',
      keywords: 'ECU tuning services, Stage 1 tuning, Stage 2 tuning, Stage 3 tuning, DPF delete, DPF solutions, EGR delete, EGR solutions, AdBlue solutions, Pops and Bangs tuning, custom ECU tuning, remote car diagnostics, fault code analysis, flash tool compatibility, automotive software integration',
    },
    '/company': {
      title: 'About RTEQ Solutions | Professional Automotive Tuning Experts | Cyprus',
      description: 'RTEQ Solutions offers 100+ specialized automotive tuning and diagnostics services worldwide. Our team includes certified WinOLS trainers and experienced automotive engineers based in Limassol, Cyprus.',
      keywords: 'RTEQ Solutions, automotive tuning company, ECU tuning experts, WinOLS trainers, automotive engineers Cyprus, professional tuning company, Limassol Cyprus tuning, vehicle tuning specialists, automotive diagnostics experts',
    },
    '/contact': {
      title: 'Contact RTEQ Solutions | ECU Tuning & Diagnostics Support | Cyprus & Greece',
      description: 'Contact RTEQ Solutions for professional ECU tuning and automotive diagnostics services. Located in Limassol, Cyprus with support in Cyprus and Greece. Free account registration available.',
      keywords: 'contact RTEQ Solutions, ECU tuning Cyprus, automotive diagnostics Greece, Limassol tuning, car tuning Cyprus, vehicle diagnostics Cyprus, RTEQ contact, automotive support Cyprus Greece',
    },
  },
  el: {
    '/': {
      title: 'RTEQ Solutions | Επαγγελματικό ECU Tuning & Διαγνωστικά Αυτοκινήτου',
      description: 'Η RTEQ Solutions είναι μια ολοκληρωμένη cloud πλατφόρμα για επαγγελματικό ECU chip tuning, απομακρυσμένη σύνδεση αυτοκινήτου και διαχείριση λογισμικού οχημάτων. Υποστηρίζει αυτοκίνητα, μοτοσικλέτες, φορτηγά, σκάφη και γεωργικά οχήματα.',
      keywords: 'ECU tuning, chip tuning, διαγνωστικά αυτοκινήτου, απομακρυσμένη σύνδεση, ECU remapping, Stage 1 tuning, Stage 2 tuning, λύσεις DPF, λύσεις EGR, λογισμικό αυτοκινήτου, πλατφόρμα tuning οχημάτων, επαγγελματικό tuning, tuning αυτοκινήτων, tuning φορτηγών, WinOLS, flash tool, υπηρεσίες αρχείων ECU, Κύπρος, Ελλάδα',
    },
    '/suite': {
      title: 'RTEQ Portal | Cloud Πλατφόρμα Tuning & Διαγνωστικών Αυτοκινήτου',
      description: 'Το RTEQ Portal είναι μια αρθρωτή cloud πλατφόρμα για διαχείριση εργασιών ECU tuning, απομακρυσμένη σύνδεση, υπηρεσίες αρχείων και βάσεις δεδομένων οχημάτων. Σχεδιασμένο για επαγγελματικά συνεργεία και εργαστήρια tuning.',
      keywords: 'RTEQ Portal, πλατφόρμα tuning αυτοκινήτου, cloud λογισμικό tuning, διαχείριση αρχείων ECU, λογισμικό διαγνωστικών, διαχείριση εργασιών tuning, πλατφόρμα απομακρυσμένης σύνδεσης, λογισμικό συνεργείου',
    },
    '/services': {
      title: 'Υπηρεσίες ECU Tuning & Διαγνωστικών | Stage 1-3, DPF, EGR | RTEQ Solutions',
      description: 'Επαγγελματικές υπηρεσίες ECU tuning: Stage 1, 2, 3, λύσεις DPF & EGR, τροποποιήσεις AdBlue, custom tuning, απομακρυσμένη σύνδεση και ενσωματωμένα εργαλεία λογισμικού αυτοκινήτου.',
      keywords: 'υπηρεσίες ECU tuning, Stage 1 tuning, Stage 2 tuning, Stage 3 tuning, λύσεις DPF, λύσεις EGR, AdBlue, Pops and Bangs, custom tuning, απομακρυσμένη σύνδεση, ανάλυση βλαβών, flash tool, λογισμικό αυτοκινήτου',
    },
    '/company': {
      title: 'Σχετικά με RTEQ Solutions | Ειδικοί στο Tuning Αυτοκινήτου | Κύπρος',
      description: 'Η RTEQ Solutions προσφέρει πάνω από 100 εξειδικευμένες υπηρεσίες tuning και διαγνωστικών αυτοκινήτου παγκοσμίως. Πιστοποιημένοι εκπαιδευτές WinOLS και έμπειροι Τεχνικοί Οχημάτων στη Λεμεσό, Κύπρο.',
      keywords: 'RTEQ Solutions, εταιρεία tuning αυτοκινήτου, ειδικοί ECU tuning, εκπαιδευτές WinOLS, Τεχνικοί Οχημάτων Κύπρος, Λεμεσός tuning, ειδικοί διαγνωστικών αυτοκινήτου',
    },
    '/contact': {
      title: 'Επικοινωνία RTEQ Solutions | ECU Tuning & Διαγνωστικά | Κύπρος & Ελλάδα',
      description: 'Επικοινωνήστε με την RTEQ Solutions για επαγγελματικές υπηρεσίες ECU tuning και διαγνωστικών αυτοκινήτου. Λεμεσός, Κύπρος με υποστήριξη σε Κύπρο και Ελλάδα.',
      keywords: 'επικοινωνία RTEQ Solutions, ECU tuning Κύπρος, διαγνωστικά αυτοκινήτου Ελλάδα, tuning Λεμεσός, tuning αυτοκινήτων Κύπρος, διαγνωστικά Κύπρος',
    },
  },
};

const PageSEO = ({ path }) => {
  const { lang } = useLanguage();
  const altLang = lang === 'el' ? 'en' : 'el';
  const pageData = seoData[lang]?.[path] || seoData.en[path] || seoData.en['/'];
  const canonicalUrl = `${DOMAIN}${path === '/' ? '' : path}`;

  return (
    <Helmet>
      <html lang={lang === 'el' ? 'el' : 'en'} />
      <title>{pageData.title}</title>
      <meta name="description" content={pageData.description} />
      <meta name="keywords" content={pageData.keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* hreflang for language alternates */}
      <link rel="alternate" hrefLang="en" href={canonicalUrl} />
      <link rel="alternate" hrefLang="el" href={canonicalUrl} />
      <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={pageData.title} />
      <meta property="og:description" content={pageData.description} />
      <meta property="og:image" content={LOGO} />
      <meta property="og:site_name" content="RTEQ Solutions" />
      <meta property="og:locale" content={lang === 'el' ? 'el_GR' : 'en_US'} />
      <meta property="og:locale:alternate" content={altLang === 'el' ? 'el_GR' : 'en_US'} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageData.title} />
      <meta name="twitter:description" content={pageData.description} />
      <meta name="twitter:image" content={LOGO} />

      {/* Geo tags for Local SEO */}
      <meta name="geo.region" content="CY-06" />
      <meta name="geo.placename" content="Limassol, Cyprus" />
      <meta name="geo.position" content="34.6823;33.0464" />
      <meta name="ICBM" content="34.6823, 33.0464" />

      {/* Robots */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
    </Helmet>
  );
};

export default PageSEO;
